import React, { Fragment, useEffect, useState } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import { Button } from 'reactstrap';
import { useQAUIContext } from '../QAUIProvider';
import QATableColumns, { QAColumns } from './QATableColumns';
import { QATableSearchBar } from './QATableSearchBar';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { getQAList, setQAFilters, toggleCheckedItemById } from '../../redux/actions';
import LoadingIcon from 'mdi-react/LoadingIcon';
import { defaultPaginationProps } from '@/shared/helpers';
import { FormGroup, Input } from 'reactstrap';
import moment from 'moment';

const QATable = () => {
  const qaUIContext = useQAUIContext();
  const dispatch = useDispatch();
  const {
    data: qaData,
    error,
    filters,
    loading,
    totalRecords,
    checkedQAIds,
  } = useSelector((state) => state.cadsAIQAData, shallowEqual);
  const {
    pageSize: rowsPerPage,
    pageNumber: page,
    sortBy: orderBy,
    isSortOrderDescending,
  } = filters;

  const [columns, setColumns] = useState(0);

  useEffect(() => {
    setColumns(QAColumns.length);
  }, [QAColumns.length]);

  React.useEffect(() => {
    dispatch(getQAList(filters));
  }, [filters]);

  const handleRequestSort = (property) => {
    dispatch(
      setQAFilters({
        sortBy: property,
        isSortOrderDescending: !isSortOrderDescending,
      }),
    );
  };

  const handleChangePage = (event, currentPage) => {
    dispatch(setQAFilters({ pageSize: rowsPerPage, pageNumber: currentPage + 1 }));
  };

  const handleChangeRowsPerPage = (event) => {
    dispatch(setQAFilters({ pageSize: +event.target.value, pageNumber: 1 }));
  };

  const emptyRows =
    page === Math.ceil(totalRecords / rowsPerPage) ? rowsPerPage - qaData.length : 0;

  return (
    <Fragment>
      <div className="material-table__wrap">
        <QATableSearchBar />
        <Table className="material-table">
          <QATableColumns
            order={isSortOrderDescending ? 'desc' : 'asc'}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={rowsPerPage}
          />
          <TableBody>
            {(loading || !!error) && (
              <TableRow>
                <TableCell colSpan={columns}>
                  {loading && (
                    <div className={'text-center overflow-hidden'}>
                      <div className="panel__refresh position-relative" style={{ height: 75 }}>
                        <LoadingIcon />
                      </div>
                    </div>
                  )}
                  <div className={'text-center'}>
                    <p className={!!error ? 'm-5' : ''}>{error || 'Loading Q&A...'}</p>
                  </div>
                </TableCell>
              </TableRow>
            )}
            {!!!qaData.length && !loading && !error && (
              <TableRow style={{ height: 120 }}>
                <TableCell colSpan={columns} align="center">
                  {filters.status === null && filters.search === ''
                    ? 'No Q&A'
                    : 'No Q&A with applied filters'}
                </TableCell>
              </TableRow>
            )}
            {qaData.map((item) => {
              return (
                <TableRow className="qa-row material-table" tabIndex={-1} key={item?.id}>
                  <TableCell align="center" className="material-table__cell">
                    <FormGroup>
                      <Input
                        type="checkbox"
                        value={item?.id}
                        defaultChecked={checkedQAIds.includes(item?.id)}
                        onChange={(e) => dispatch(toggleCheckedItemById(+e.target.value))}
                      />
                    </FormGroup>
                  </TableCell>
                  <TableCell
                    align="center"
                    className="material-table__cell"
                    onClick={() => qaUIContext.openViewQADialog(item?.id)}
                  >
                    {item.questionTitle}
                  </TableCell>
                  <TableCell
                    className="material-table__cell"
                    align="center"
                    onClick={() => qaUIContext.openViewQADialog(item?.id)}
                  >
                    {item.postedBy}
                  </TableCell>
                  <TableCell
                    align="center"
                    className="material-table__cell"
                    onClick={() => qaUIContext.openViewQADialog(item?.id)}
                  >
                    {item.postedByEmail}
                  </TableCell>
                  <TableCell align="center" className="material-table__cell">
                    {item.datePosted ? moment(item.datePosted).format('DD/MM/yyyy') : '-'}
                  </TableCell>
                </TableRow>
              );
            })}
            {emptyRows > 0 && (
              <TableRow style={{ height: 49 * emptyRows }}>
                <TableCell colSpan={columns} />
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
      <TablePagination
        count={totalRecords}
        rowsPerPage={rowsPerPage}
        page={page - 1}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        component={defaultPaginationProps.component}
        backIconButtonProps={defaultPaginationProps.backIconButton}
        nextIconButtonProps={defaultPaginationProps.nextIconButton}
        rowsPerPageOptions={defaultPaginationProps.rowsPerPage}
        className={defaultPaginationProps.className}
        dir={defaultPaginationProps.dir}
      />
    </Fragment>
  );
};

export default QATable;
